export default class globalStyles {
  static main_darkblue_color = '#242B5C';

  static secondary_darkblue_color = '#1F3047';

  static main_blue_color = '#40A9FF';
}
